/* esm.sh - @radix-ui/react-accordion@1.2.12 */
export * from "/*@radix-ui/react-accordion@1.2.12/esnext/react-accordion.mjs";
